import { Component, OnInit } from '@angular/core';
import { RequestService } from 'src/app/shared/services/request/request.service';
import { BaseComponent } from '../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { TaskService } from 'src/app/shared/services/task/task.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-melting-point',
  templateUrl: './melting-point.component.html',
  styleUrls: ['./melting-point.component.less']
})
export class MeltingPointComponent extends BaseComponent implements OnInit {
  ngOnInit() {}

  constructor(
    public route: ActivatedRoute,
    public taskService: TaskService,
    public router: Router,
    public sanitizer: DomSanitizer,
    public toastr: ToastrService,
    private formBuilder: FormBuilder,
    public requestService: RequestService,
    public activeRoute: ActivatedRoute
  ) {
    super(route, taskService, router, sanitizer, toastr, activeRoute);
  }

  showRequest(data) {
    const request = this.requestService.createMeltingPoint(data);
    this.post(request);
  }
}
